module.exports = __webpack_public_path__ + "images/172_1024.jpg";